
import React from 'react';
import { Button } from '@/components/ui/button';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

export function ContactSection() {
  const contactInfo = [
    {
      icon: Mail,
      title: "Email us",
      details: "hello@atwork.ai",
      description: "We'll respond within 24 hours"
    },
    {
      icon: Phone,
      title: "Call us",
      details: "+1 (555) 123-4567",
      description: "Mon-Fri from 8am to 6pm"
    },
    {
      icon: MapPin,
      title: "Visit us",
      details: "San Francisco, CA",
      description: "Come say hello at our office"
    },
    {
      icon: Clock,
      title: "Chat with us",
      details: "Live chat",
      description: "We're online right now"
    }
  ];

  return (
    <div className="py-20 px-4 bg-accent/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
            Get in <span className="text-yellow-400">touch</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Ready to transform your business? Let's talk about how atWork.ai can help you grow.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Contact Form */}
          <div className="bg-card border border-border rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-foreground mb-6">Send us a message</h3>
            <form className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="firstName" className="block text-sm font-medium text-foreground mb-2">
                    First name
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder-muted-foreground focus:border-yellow-400 focus:ring-yellow-400 focus:ring-1 transition-colors"
                    placeholder="John"
                  />
                </div>
                <div>
                  <label htmlFor="lastName" className="block text-sm font-medium text-foreground mb-2">
                    Last name
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder-muted-foreground focus:border-yellow-400 focus:ring-yellow-400 focus:ring-1 transition-colors"
                    placeholder="Doe"
                  />
                </div>
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-foreground mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder-muted-foreground focus:border-yellow-400 focus:ring-yellow-400 focus:ring-1 transition-colors"
                  placeholder="john@example.com"
                />
              </div>
              
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-foreground mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  rows={4}
                  className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder-muted-foreground focus:border-yellow-400 focus:ring-yellow-400 focus:ring-1 transition-colors resize-none"
                  placeholder="Tell us about your project..."
                />
              </div>
              
              <Button className="w-full bg-yellow-400 text-neutral-900 hover:bg-yellow-300 text-lg py-3 rounded-lg font-semibold">
                Send message
              </Button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="space-y-8">
            {contactInfo.map((info, index) => (
              <div key={index} className="flex items-start space-x-4 p-6 bg-card border border-border rounded-xl hover:bg-accent/50 transition-colors">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-yellow-400/10 border border-yellow-400/20 rounded-lg flex items-center justify-center">
                    <info.icon className="w-6 h-6 text-yellow-400" />
                  </div>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-foreground mb-1">{info.title}</h4>
                  <p className="text-yellow-400 font-medium mb-1">{info.details}</p>
                  <p className="text-muted-foreground text-sm">{info.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
